import { useQuery } from '@tanstack/react-query';
import LaunchDarklyFetch from 'fetch/LaunchDarklyFetch';

/*
returns toggle state from Launch darkly for the given toggle. The staleTime
and cacheTime can be passed in a parameters or will use the default values
provided in constants.

Note: toggle name should be LaunchDarkly snake_case toggle name
*/

const STALE_TIME_DEFAULT = 1000 * 60 * 4;
const CACHE_TIME_DEFAULT = 1000 * 60 * 4;

export const useToggle = (
  name: string, // snake_case_toggle_name
  staleTime: number = STALE_TIME_DEFAULT,
  cacheTime: number = CACHE_TIME_DEFAULT
) => {
  const userInfo = localStorage.getItem('user.info');

  if (!userInfo) return { data: false, isLoading: false, isError: false, error: null };

  const uInfo = JSON.parse(userInfo || '{}');

  const userInfoString = uInfo?.id ? uInfo.id : '';

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['toggle' + userInfoString + name],
    queryFn: () => LaunchDarklyFetch.getLaunchDarklyVariation(name),
    retry: false,
    staleTime: staleTime, // refresh toggle every 4 hours
    cacheTime: cacheTime, // clear toggle cache every 4 hours
  });

  return { data: data?.value ? data.value : false, isLoading, isError, error };
};
